import React, { FC, useEffect } from 'react';
import { Crash } from '../../components/crash/Crash';
import { CommonAppProviders } from './CommonAppProviders';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { MarkNotificationAsRead } from '../notifications/MarkNotificationAsRead';
import { IncompatibleBrowser } from '../incompatible-browser/IncompatibleBrowser';
import { GlobalModalesWizard } from '../modales/GlobalModalesWizard';
import { FetchUserWatchers } from '../../watchers/components/fetch-user-watchers/FetchUserWatchers';
import { DoctrineRoutes } from './DoctrineRoutes';
import { CustomToastContainer } from '../../components/toaster/CustomToastContainer';
import { ReduxProviders } from './ReduxProviders';
import { CrashHandler } from './CrashHandler';
import { displayCookieBannerWhenNeeded } from '../../cookies/handleCookiesPolicy';

export const AppWrapper: FC = ({ children }) => {
  useEffect(() => {
    if (window.send_analytics_events) {
      window.send_analytics_events.forEach((analyticsEvents) => {
        doctrineAnalytics(analyticsEvents.event, analyticsEvents.data);
      });
    }

    displayCookieBannerWhenNeeded();
  }, []);

  return (
    <Crash>
      <ReduxProviders>
        <CommonAppProviders isLoggedIn={window.logged_in}>
          <CrashHandler>
            <DoctrineRoutes>{children}</DoctrineRoutes>
          </CrashHandler>
          <div id="popover-root" />
          {/* data-nosnippet is to prevent google to show the content in SERP */}
          <div data-react="cookies-banner" data-nosnippet />

          <CustomToastContainer />
          <FetchUserWatchers />
          <MarkNotificationAsRead />
          <GlobalModalesWizard />
          <IncompatibleBrowser />
        </CommonAppProviders>
      </ReduxProviders>
    </Crash>
  );
};
